__webpack_require__.p = "https://dcs-static.gprod.postmedia.digital/20.0.2/websites/js/";